export const findCategory = (state) => (id) => {
  if (state.available && state.available.length > 0) {
    return state.available.find((entry) => entry.id === id);
  }

  return null;
};
